export default __webpack_public_path__ + "static/media/icon-checkmark-green-circle.e8b0a62f.svg";